import React from 'react'
import Navbar from '../components/maketApp/site/Navbar'

import Footer from '../components/maketApp/site/Footer'

import FormationsCards from '../components/maketApp/site/FormationsCards'
import HerosFormation from '../components/maketApp/site/HerosFormation'

const FormationsPages = () => {
  return (
    <div>
       <Navbar />
       <HerosFormation />
       <FormationsCards />

         <Footer />
    </div>
  )
}

export default FormationsPages
